<template>
  <multiselect 
    placeholder="Select Vehicle"
    :options="vehicles.data" 
    label="objectname" 
    track-by="id" 
    :value="selected" 
    @search-change="handleSearch"
    @input="handleInput" 
    @remove="handleRemove">
    <template slot="option" slot-scope="props">
      <div>{{ props.option.objectname }}</div>
      <div class="mt-1 text-sm text-gray-500 ">{{ props.option.objectno }}</div>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'VehicleSelect',

  components: {
    Multiselect
  },

  created () {
    this.getVehicles()
  },

  props: ['value'],

  computed: {
    selected () {
      return this.vehicles.data.find(vehicle => vehicle.id === this.value)
    }
  },

  data () {
    return {
      vehicles: {
        data: []
      }
    }
  },

  methods: {
    async getVehicles (query) {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/vehicles`, {
          params: {
            search: query
          }
        })
        this.vehicles = data.vehicles
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    handleSearch (query) {
      this.getVehicles(query)
    },

    handleInput (value) {
      this.$emit('input', value.id)
    },

    handleRemove () {
      this.$emit('input', null)
    }
  }
}
</script>